import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// Create slice

const initialKiosksData = {
  // podID: null,
  // maintenanceStatus: null,
  // activeStatus: null,
  podID: 0,
  kioskCode: "",
  maintenanceStatus: 2,
  activeStatus: 2,
  facilityID: 0,
  pageNo: 1,
  rowCountPerPage: 10,
  sortBy:""
};

const name = "kiosks";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const kiosksActions = { ...slice.actions, ...extraActions };
export const kiosksReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    kiosksList: [],
    kiosksExcelList: [],
    shuffleStatus: [],
    KioskInfo: [],
    addKiosksData: [],
    updateKiosksData: [],

    kiosksSearch: initialKiosksData,
    initialKiosksData,
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    clearaddKiosks,
    clearupdateKiosks,
    clearKisokInfo,
    clearshuffleStatus,
    clearkiosksExcelList,
    setKiosksSearch,
    clearKiosks,
  };
  /// clear funcs

  function clearKisokInfo(state) {
    state.KioskInfo = [];
  }
  function clearupdateKiosks(state) {
    state.updateKiosksData = [];
  }
  function clearaddKiosks(state) {
    state.addKiosksData = [];
  }

  function clearshuffleStatus(state) {
    state.shuffleStatus = 0;
  }
  function clearkiosksExcelList(state) {
    state.kiosksExcelList = [];
  }

  function setKiosksSearch(state, action) {
    state.kiosksSearch = action && action.payload;
  }

  function clearKiosks(state) {
    state.kiosksSearch = initialKiosksData;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Kiosk`;

  return {
    LoadKioskList: LoadKioskList(),
    UpdateKeyboardShuffleStatus: UpdateKeyboardShuffleStatus(),
    GetKioskInfo: GetKioskInfo(),
    CreateKiosk: CreateKiosk(),
    UpdateKiosk: UpdateKiosk(),
  };

  // load grid
  function LoadKioskList() {
    return createAsyncThunk(`${name}/LoadKioskList`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/LoadKioskList`, params);
    });
  }

  /// shuffle status ..
  function UpdateKeyboardShuffleStatus() {
    return createAsyncThunk(
      `${name}/UpdateKeyboardShuffleStatus`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/UpdateKeyboardShuffleStatus`,
          params
        );
      }
    );
  }

  /// GetKioskInfo..
  function GetKioskInfo() {
    return createAsyncThunk(`${name}/GetKioskInfo`, async (KiosksID) => {
      return await fetchWrapper.get(
        `${baseUrl}/GetKioskInfo?KiosksID=${KiosksID}`
      );
    });
  }

  ///Create Kiosk..
  function CreateKiosk() {
    return createAsyncThunk(`${name}/CreateKiosk`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/CreateKiosk`, params);
    });
  }

  ///Update Kiosk..
  function UpdateKiosk() {
    return createAsyncThunk(`${name}/UpdateKiosk`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/UpdateKiosk`, params);
    });
  }
}

function createExtraReducers(builder) {
  builder
    // grid load
    .addCase(extraActions.LoadKioskList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadKioskList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.kiosksExcelList = action.payload;
      } else {
        state.kiosksList = action.payload;
      }
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.LoadKioskList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    // shuffle status
    .addCase(extraActions.UpdateKeyboardShuffleStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.UpdateKeyboardShuffleStatus.fulfilled,
      (state, action) => {
        state.loading = false;
        state.shuffleStatus = action.payload;
      }
    )
    .addCase(
      extraActions.UpdateKeyboardShuffleStatus.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    /// GetKioskInfo
    .addCase(extraActions.GetKioskInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetKioskInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.KioskInfo = action.payload;
    })
    .addCase(extraActions.GetKioskInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    /// Create Kiosk
    .addCase(extraActions.CreateKiosk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.CreateKiosk.fulfilled, (state, action) => {
      state.loading = false;
      state.addKiosksData = action.payload;
    })
    .addCase(extraActions.CreateKiosk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /// UpdateKiosk
    .addCase(extraActions.UpdateKiosk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.UpdateKiosk.fulfilled, (state, action) => {
      state.loading = false;
      state.updateKiosksData = action.payload;
    })
    .addCase(extraActions.UpdateKiosk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
